<template>
    <div class="custom-modal showTabs secondary-color headerTab openHeader">
    	<div class="mainContent position-relative">
    		<ul class="tabingPop statementBp d-flex align-items-center justify-content-center border-bottom mt-2">
				<li :class="(statement == 'Account Statement')?'active':' '">
					<a @click="statement = 'Account Statement' " href="#">Account Statement</a>
				</li>
				<li :class="(statement == 'Trading Statistics')?'active':' '">
					<a @click="statement = 'Trading Statistics' " href="#">Trading Statistics</a>
				</li>
			</ul>
		<div class="mainTab-one" v-if="statement == 'Account Statement'">
			<span class="closePOP" @click="statement = ''"><feather size="13px" type="x"></feather></span>
    	<form class="updateWrap">
    	 	<div class="twoColmn d-flex align-items-center">
				<div class="form-fields d-flex align-items-center mb-3">
					<select class="selectBox">
						<option>Time Format</option>
						<option>Day </option>
						<option>Week </option>
						<option>Month  </option>
						<option>Quarter  </option>
						<option>Year</option>
						<option>Since Open</option>
						<option>Previous Month</option>
						<option>Previous Quarter  </option>
						<option>Previous Year </option>
					</select>
				</div>
		    </div>
		    <div class="oneColmn">
			    <div class="includeLabe">
				    <div class="form-fields d-flex align-items-center mb-3 labelInput">
						<label>Date (DD/MM/YYYY)</label>
						<div class="twoColmn d-flex align-items-center justify-content-end w-100 p-0">
							<div class="d-flex align-items-center seleceDate">
								<select class="selectBox">
									<option value="">From</option>
									<option>10-02-21</option>
									<option>10-02-21</option>
									<option>10-02-21</option>
								</select>
								<select class="selectBox">
									<option value="">Till</option>
									<option>12-10-21</option>
									<option>GMT Time Zone</option>
									<option>GMT Time Zone</option>
								</select>
							</div>
					    </div>
					</div>
				</div>
			</div>
		    <div class="twoColmn d-flex align-items-center">
				<div class="form-fields d-flex align-items-center mb-3">
					<select class="selectBox">
						<option>Rows Per Page</option>
						<option>20</option>
						<option>40</option>
						<option>60</option>
						<option>80</option>
						<option>No Pagination </option>
					</select>
				</div>
				<div class="form-fields d-flex align-items-center mb-3">
					<select class="selectBox">
						<option>Print Text Size</option>
						<option>14</option>
						<option>12</option>
						<option>10</option>
						<option>8</option>
						<option>6</option>
					</select>
				</div>
		    </div>
		   
			<div class="oneColmn">
				<div class="form-fields mb-3">
					<select class="selectBox">
						<option>Show Order / Position Size In</option>
						<option>Amount </option>
						<option>Lot</option>
					</select>
				</div>
			</div>
			<!-- <div class="twoColmn d-flex align-items-center justify-content-between mb-3">
				<label class="customCheckbox">Simple Form
				  <input type="checkbox" checked="checked">
				  <span class="checkmark"></span>
				</label>
				<label class="customCheckbox">Use 2 Currency Decimal Digits
				  <input type="checkbox">
				  <span class="checkmark"></span>
				</label>
			</div> -->
			<div class="twoColmn d-flex align-items-center justify-content-between mb-3">
				<label class="customCheckbox">Show Comments
				  <input type="checkbox">
				  <span class="checkmark"></span>
				</label>
				<label class="customCheckbox">Show Balance & Equity
				  <input type="checkbox">
				  <span class="checkmark"></span>
				</label>
			</div>
			<div class="twoColmn d-flex align-items-center justify-content-between mb-3">
				<label class="customCheckbox">Group by instrument type 
				  <input type="checkbox">
				  <span class="checkmark"></span>
				</label>
			</div>
			<!-- <div class="twoColmn d-flex align-items-center justify-content-between mb-3">
				<label class="customCheckbox">Group by Instrument Type
				  <input type="checkbox">
				  <span class="checkmark"></span>
				</label>
				<label class="customCheckbox">MarkUp
				  <input type="checkbox">
				  <span class="checkmark"></span>
				</label>
			</div> -->
			<div class="fullWidh w-100 text-center mt-4 h-50p">
				<a href="#" class="btn appButton linkBG mx-auto justify-content-center large">Generate Account Statement Report</a>
			</div>
		</form>
	    </div>
	    <div class="mainTab-one" v-if="statement == 'Trading Statistics'">
	    	<span class="closePOP" @click="statement = ''"><feather size="13px" type="x"></feather></span>
    	 <form class="updateWrap">
    	 	<div class="twoColmn d-flex align-items-center">
				<div class="form-fields d-flex align-items-center mb-3">
					<select class="selectBox">
						<option>Time Format</option>
						<option>Day </option>
						<option>Week </option>
						<option>Month  </option>
						<option>Quarter  </option>
						<option>Year</option>
						<option>Since Open</option>
						<option>Previous Month</option>
						<option>Previous Quarter  </option>
						<option>Previous Year </option>
					</select>
				</div>
		    </div>
		    <div class="oneColmn">
			    <div class="includeLabe">
				    <div class="form-fields d-flex align-items-center mb-3 labelInput">
						<label>Date (DD/MM/YYYY)</label>
						<div class="twoColmn d-flex align-items-center justify-content-end w-100 p-0">
							<div class="d-flex align-items-center seleceDate">
								<select class="selectBox">
									<option value="">From</option>
									<option>10-02-21</option>
									<option>10-02-21</option>
									<option>10-02-21</option>
								</select>
								<select class="selectBox">
									<option value="">Till</option>
									<option>12-10-21</option>
									<option>GMT Time Zone</option>
									<option>GMT Time Zone</option>
								</select>
							</div>
					    </div>
					</div>
				</div>
			</div>
		     <div class="twoColmn d-flex align-items-center">
				<div class="form-fields d-flex align-items-center mb-3">
					<select class="selectBox">
						<option>Rows Per Page</option>
						<option>20</option>
						<option>40</option>
						<option>60</option>
						<option>80</option>
						<option>No Pagination </option>
					</select>
				</div>
				<div class="form-fields d-flex align-items-center mb-3">
					<select class="selectBox">
						<option>Print Text Size</option>
						<option>14</option>
						<option>12</option>
						<option>10</option>
						<option>8</option>
						<option>6</option>
					</select>
				</div>
		    </div>
		  
			<div class="twoColmn d-flex align-items-center">
				<div class="form-fields mb-3">
					<select class="selectBox">
						<option>All Instruments</option>
						<option>EURUSD </option>
						<option>GBPUSD</option>
						<option>USDCHF</option>
						<option>USDJPY</option>
					</select>
				</div>
				<div class="form-fields d-flex align-items-center mb-3">
						<select class="selectBox">
							<option>Show Order / Position Size In </option>
							<option>Amount </option>
							<option>Lots </option>
						</select>
					</div>
			</div>
			<!-- <div class="twoColmn d-flex align-items-center mb-3">
				<label class="customCheckbox">Use 2 Currency Decimal Digits
				  <input type="checkbox">
				  <span class="checkmark"></span>
				</label>
			</div> -->
			<div class="fullWidh w-100 text-center mt-5 h-50p">
				<a href="#" class="btn appButton linkBG mx-auto justify-content-center large">Generate Trading Statistics Report</a>
			</div>
		</form>
	    </div>
	</div>
    </div>
</template>

<script>
export default {
    name: 'report-setting',
    data() {
        return {
            statement:'Account Statement',
        }
    }
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/shared/sidebar-popup/reports-setting.vue